const ADDITIONAL_OFFER = 'additional-offer';
const PRELIMINARY_OFFER = 'preliminary-offer';

export { ADDITIONAL_OFFER, PRELIMINARY_OFFER };
